import {
	GET_EXPORT_CONTENT,
	GET_EXPORT_PAGES_CONTENT,
	PARSE_XML_NODES,
	CHANGE_EXPORT_FILE,
	START_OVER,
	UPDATE_SELECTED_PAGES,
	SHOW_DRAFT_PAGES,
	SHOW_PUBLISHED_PAGES
} from './constants';

export const getExportContent = (text) => ({
	type: GET_EXPORT_CONTENT,
	payload: text
})

export const getExportPagesContent = (text) => {

	return {
		type: GET_EXPORT_PAGES_CONTENT,
		payload: text
	}
}

export const parseXMLNodes = (xmlString) => {

	return {
		type: PARSE_XML_NODES,
		payload: xmlString
	}
}

export const changeExportFile = (file) => ({
	type: CHANGE_EXPORT_FILE,
	payload: file
})

export const startOver = () => ({
	type: START_OVER
})

export const updateSelectedPages = (pages) => ({
	type: UPDATE_SELECTED_PAGES,
	payload: pages
})

export const showDraftPages = (boolean) => ({
	type: SHOW_DRAFT_PAGES,
	payload: boolean
})

export const showPublishedPages = (boolean) => ({
	type: SHOW_PUBLISHED_PAGES,
	payload: boolean
})